import "./LoadingClock.scss";

export const LoadingClock = ({ label = "Carregando..." }: { label?: string }) => (
  <div className="miboard-loading-clock" role="status" aria-live="polite">
    <div className="miboard-loading-clock__dial">
      <span className="miboard-loading-clock__hand" />
    </div>
    <span className="miboard-loading-clock__label">{label}</span>
  </div>
);
